import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box, Flex } from '@chakra-ui/react';
import { motion, useReducedMotion } from "framer-motion";
import TopbarPerfil from './TopbarPerfil';
import NavbarPerfil, { PerfilDesktopSidebar } from './NavbarPerfil';
import { PerfilGuard } from "./PerfilGuard";

const MotionBox = motion.create(Box);

const MainLayout = () => {
  const { pathname } = useLocation();
  const onboarding = pathname === "/perfil/onboarding";
  const familyEditor = pathname.startsWith("/perfil/familia/");
  const registrationEditor = pathname.startsWith("/perfil/registro/");
  const immersive = onboarding || familyEditor || registrationEditor;
  const shellBg = "public.bg.canvas";
  const shellFg = "public.fg.default";
  const reduceMotion = useReducedMotion();
  return (
    <PerfilGuard>
      <Box bg={shellBg} minH="100dvh" position="relative" overflow="hidden" css={{
        "--chakra-colors-design-bg-canvas": "var(--chakra-colors-public-bg-canvas)",
        "--chakra-colors-design-bg-panel": "var(--chakra-colors-public-bg-panel)",
        "--chakra-colors-design-bg-surface": "var(--chakra-colors-public-bg-surface)",
        "--chakra-colors-design-bg-muted": "var(--chakra-colors-public-bg-muted)",
        "--chakra-colors-design-bg-elevated": "var(--chakra-colors-public-bg-elevated)",
        "--chakra-colors-design-fg-default": "var(--chakra-colors-public-fg-default)",
        "--chakra-colors-design-fg-muted": "var(--chakra-colors-public-fg-muted)",
        "--chakra-colors-design-fg-subtle": "var(--chakra-colors-public-fg-subtle)",
        "--chakra-colors-design-border-default": "var(--chakra-colors-public-border-default)",
        "--chakra-colors-design-border-subtle": "var(--chakra-colors-public-border-subtle)",
      }}>
        {!immersive && <>
          <MotionBox position="absolute" boxSize={{ base: "210px", lg: "360px" }} rounded="full" bg="#dce8f1" _dark={{ bg: "#243746" }} right={{ base: "-130px", lg: "-110px" }} top={{ base: "12%", lg: "-90px" }} opacity=".62" animate={reduceMotion ? undefined : { scale: [1, 1.07, .98, 1], rotate: [0, 5, -3, 0] }} transition={{ duration: 9, repeat: Infinity, ease: "easeInOut" }}/>
          <MotionBox position="absolute" w={{ base: "240px", lg: "390px" }} h={{ base: "100px", lg: "170px" }} rounded="full" bg="#eadde8" _dark={{ bg: "#3d3040" }} left={{ base: "-140px", lg: "42%" }} bottom={{ base: "8%", lg: "-95px" }} opacity=".54" animate={reduceMotion ? undefined : { scaleX: [1, 1.08, .96, 1], scaleY: [1, .95, 1.05, 1], rotate: [-14, -19, -10, -14] }} transition={{ duration: 10.5, repeat: Infinity, ease: "easeInOut" }}/>
        </>}
        <Flex position="relative" zIndex="1" direction={immersive ? "column" : { base: "column", lg: "row" }} minH="100dvh" bg="transparent" maxW={immersive ? "1200px" : "1440px"} mx="auto">
          {!immersive && <PerfilDesktopSidebar/>}
          <Flex direction="column" flex="1" minW="0" minH="100dvh">
          {!immersive && <TopbarPerfil scrollContainerId="scrollableBody"/>}
          <Box as="main" flex="1" minH={{ base: "calc(100dvh - 76px)", lg: "auto" }} overflow="auto" color={shellFg} p={immersive ? "0" : { base: "5 5 104px", md: "7 7 112px", lg: "9" }} id="scrollableBody">
            <Outlet />
          </Box>
          {!immersive && <NavbarPerfil />}
          </Flex>
        </Flex>
      </Box>
    </PerfilGuard>
  );
};

export default MainLayout;
